import React from "react";
import "../styles/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="policy-container">
      <h1>SHADE - SHare A riDE: Terms and Conditions</h1>
      <p className="updated-date">Last Updated: 05/04/2024</p>

      <p>Welcome to SHADE. SHADE provides an online platform that connects bike owners/riders ("Leads") with individuals seeking a ride ("Fare Payers" or "FPs")...</p>

      <h2>1. Definitions</h2>
      <ul>
        <li><strong>App:</strong> The SHADE mobile application.</li>
        <li><strong>User:</strong> Anyone who registers for and uses the SHADE App...</li>
        <li><strong>Lead:</strong> A registered User who owns or has legal access to a two-wheeler...</li>
        <li><strong>Fare Payer (FP):</strong> A registered User who requests, books, and pays...</li>
        <li><strong>Ride:</strong> The shared journey...</li>
        <li><strong>User Content:</strong> Any information, text, graphics, photos...</li>
        <li><strong>Service:</strong> The platform services provided by SHADE...</li>
      </ul>

      <h2>2. The SHADE Service</h2>
      <p>SHADE provides a platform to facilitate peer-to-peer ride-sharing on two-wheelers...</p>

      <h2>3. User Eligibility and Accounts</h2>
      <p>You must be at least 18 years old...</p>
      <ul>
        <li>Full Name</li>
        <li>Valid Phone number</li>
        <li>Valid Email Address</li>
        <li>Aadhar Number...</li>
        <li>Profile Picture</li>
        <li>For Leads: Driving License, Vehicle Details</li>
      </ul>

      <h2>4. Role-Specific Obligations</h2>
      <p><strong>Lead Obligations:</strong> Valid license, safety, helmet, legality, etc.</p>
      <p><strong>Fare Payer Obligations:</strong> Timeliness, helmet, behavior, payment, etc.</p>

      <h2>5. Ride Posting, Booking, and Pricing</h2>
      <p>Rides are posted by Leads, booked by FPs. Pricing shown in-app...</p>

      <h2>6. Safety Features</h2>
      <ul>
        <li>Live Tracking</li>
        <li>Share Location</li>
        <li>Emergency Assistance</li>
        <li>Report User</li>
      </ul>

      <h2>7. User Conduct</h2>
      <p>Respect others, follow the law, no harassment or illegal activity...</p>

      <h2>8. Disclaimers</h2>
      <p>SHADE is a platform, not a transport provider. All rides are at users’ risk...</p>

      <h2>9. Limitation of Liability</h2>
      <p>SHADE is not liable for indirect, incidental, or consequential damages...</p>

      <h2>10. Indemnification</h2>
      <p>You agree to hold SHADE harmless for any claims or damages...</p>

      <h2>11. Termination</h2>
      <p>SHADE may terminate your account at its discretion...</p>

      <h2>12. Governing Law and Dispute Resolution</h2>
      <p>Subject to laws of India. Jurisdiction: Coimbatore, Tamil Nadu...</p>

      <h2>13. Changes to Terms</h2>
      <p>We may update these terms and notify users accordingly...</p>

      <h2>14. Contact Information</h2>
      <p>SHADE<br/>
        Email: <a href="mailto:theshadeapp@gmail.com">theshadeapp@gmail.com</a><br/>
        Phone: 9629846693<br/>
        Address: 12 C Bharathi Nagar, GN Mills, Thudiyalur Road,<br/>
        Coimbatore, Tamil Nadu, India - 641029
      </p>

      <hr/>

      <h1>SHADE - SHare A riDE: Privacy Policy</h1>
      <p className="updated-date">Last Updated: 05/04/2024</p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li>Personal Identification (Name, Phone, Email, Aadhar, etc.)</li>
        <li>Lead Info (License, Vehicle details)</li>
        <li>Real-Time Location</li>
        <li>Usage & Device Info</li>
        <li>Emergency Contacts</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>Service delivery</li>
        <li>Verification</li>
        <li>Safety and Legal compliance</li>
        <li>Personalization and communication</li>
      </ul>

      <h2>3. How We Share Your Information</h2>
      <ul>
        <li>Between Leads & FPs</li>
        <li>With emergency contacts</li>
        <li>For verification with trusted providers</li>
        <li>Legal requests or business transfers</li>
      </ul>

      <h2>4. Data Security</h2>
      <p>We use reasonable encryption and security protocols to protect your data.</p>

      <h2>5. Data Retention</h2>
      <p>We retain necessary data for legal, safety, and business reasons.</p>

      <h2>6. Your Rights and Choices</h2>
      <ul>
        <li>View/edit profile info</li>
        <li>Request account deletion</li>
        <li>Control location access</li>
      </ul>

      <h2>7. Children’s Privacy</h2>
      <p>Not for users under 18. We do not knowingly collect data from minors.</p>

      <h2>8. Changes to this Policy</h2>
      <p>We may update the policy and notify users through the App.</p>

      <h2>9. Contact Information</h2>
      <p>SHADE<br/>
        Email: <a href="mailto:theshadeapp@gmail.com">theshadeapp@gmail.com</a><br/>
        Phone: 9629846693<br/>
        Address: 12 C Bharathi Nagar, GN Mills, Thudiyalur Road,<br/>
        Coimbatore, Tamil Nadu, India - 641029
      </p>
    </div>
  );
};

export default PrivacyPolicy;
